import {
  MultiplierBreakdown,
  Tier,
  BASE_POINTS,
  SPEED_BONUS_TIERS,
  STREAK_MULTIPLIER_TIERS,
  TIER_MULTIPLIERS,
} from '../types/game';

export function calculateMultipliers(
  answerTimeSeconds: number,
  streak: number,
  tier: Tier,
): MultiplierBreakdown {
  // Speed multiplier
  let speedMultiplier = 1;
  for (const t of SPEED_BONUS_TIERS) {
    if (answerTimeSeconds <= t.maxSeconds) {
      speedMultiplier = t.multiplier;
      break;
    }
  }

  // Streak multiplier
  let streakMultiplier = 1;
  for (const t of STREAK_MULTIPLIER_TIERS) {
    if (streak >= t.minStreak) {
      streakMultiplier = t.multiplier;
      break;
    }
  }

  // Tier multiplier
  const tierMultiplier = TIER_MULTIPLIERS[tier];

  const total = Math.round(BASE_POINTS * speedMultiplier * streakMultiplier * tierMultiplier);

  return {
    base: BASE_POINTS,
    speedMultiplier,
    streakMultiplier,
    tierMultiplier,
    total,
  };
}
